<template>
  <div class="item" :id="`solution${index}`">
    <div class="item-header">
      <div class="item-header-title">EQUAL PROTECTION SOLUTIONS</div>
      <div class="item-header-name">
        <span class="item-header-name-line" />
        <span>等保</span>
        <span class="bold">解决方案</span>
        <span class="item-header-name-line" />
      </div>
      <div class="item-header-desc">风险攻击面增加 网络边界被打破</div>
    </div>

    <div class="item-content">
      <div class="tabs">
        <div :key="i" v-for="(item,i) in currentTabs" :class="tabClasses(i)" @click="tabClick(i)">
          <span>{{item.name}}</span>
        </div>
      </div>
      <div class="tabs-content">
        <div class="imgs" :style="getWrapStyle">
          <img
            :key="i" 
            v-for="(item,i) in currentTabs"
            :src="'http://tarzan.minus.live' + item.img"
            @click="showBoard"
            @load="(node) => loadImage(node, i)"
            :height="imgHeight[i] ? imgHeight[i] : 0" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Img from '../../assets/images/solution/img-6-1.png'

export default {
  data () {
    return {
      Img,
      tabActiveIndex: 0,
      currentTabs: this.tabs.filter(item => (item.desc === 'retentionSolution')),
      imgHeight: []
    }
  },

  props: {
    tabs: {
      type: Array,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  },

  methods: {
    showBoard () {
      window.eventBus.$emit('boardShow')
    },

    tabClick (index) {
      this.tabActiveIndex = index
    },

    tabClasses (index) {
      return `tab ${index == this.tabActiveIndex ? 'active' : ''}`
    },

    getWidth () {
      let translateX = 664
      const width = document.body.getBoundingClientRect().width
      if (width > 1280 && width <= 1680) {
        translateX = 996
      } else if (width >= 1920) {
        translateX = 1328
      }
      return translateX
    },

    loadImage (node, i) {
      const width = this.getWidth()
      const imgHeight = [...this.imgHeight]
      imgHeight[i] = width / node.path[0].naturalWidth * node.path[0].naturalHeight
      this.imgHeight = imgHeight
    },

    getImgStyle (i) {
      if (this.imgHeight[i]) {
        return {
          height: this.imgHeight[i] + 'px'
        }
      }
    }
  },

  computed: {
    getWrapStyle () {
      const translateX = this.getWidth()
      return {
        width: translateX * this.currentTabs.length + 'px',
        transform: `translateX(${this.tabActiveIndex * -translateX}px)`
      }
    },
  },

  watch: {
    tabs (newValue) {
      this.currentTabs = newValue.filter(item => (item.desc === 'retentionSolution')) || []
    }
  }
}
</script>

<style lang="less" scoped>
.item-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.item-btn {
  width: 96px;
  height: 28px;
  border-radius: 14px;
  background-color: #f45937;
  color: #fff;
  font-size: 9px;
  line-height: 28px;
  text-align: center;
  cursor: pointer;

  @media (min-width: 1280px) and (max-width: 1680px){
    width: 144px;
    height: 42px;
    border-radius: 21px;
    font-size: 14px;
    line-height: 42px;
    margin-top: 30px;
  }
        
  @media screen and (min-width: 1920px){
    width: 192px;
    height: 56px;
    border-radius: 28px;
    font-size: 18px;
    line-height: 56px;
    margin-top: 40px;
  }
}
.tabs {
  display: flex;

  .tab {
    padding: 10px 60px;
    margin: 0 60px;
    cursor: pointer;
    border-bottom: 1px dashed #d3d3d3;

    @media (min-width: 1280px) and (max-width: 1680px){
      padding: 15px 90px;
      margin: 0 90px;
    }
          
    @media screen and (min-width: 1920px){
      padding: 20px 120px;
      margin: 0 120px;
    }
  }

  .tab.active {
    border-color: #f45937;
  }
}

.tabs-content {
  display: flex;
  margin: 40px 0px 0px 0px;
  background-size: 100% 100%;
  width: 100%;
  width: 664px;
  overflow: hidden;

  @media (min-width: 1280px) and (max-width: 1680px){
    width: 996px;
  }
        
  @media screen and (min-width: 1920px){
    width: 1328px;
  }

  .imgs {
    display: flex;
    transition: all .5s ease-in-out;
  }
  
  img {
    width: 664px;
    height: 333px;

    @media (min-width: 1280px) and (max-width: 1680px){
      width: 996px;
      height: 499px;
    }
          
    @media screen and (min-width: 1920px){
      width: 1328px;
      height: 666px;
    }
  }
}
</style>